<template>
  <div></div>
</template>

<script>
export default {
  name: "ResultsView"
}
</script>

<style scoped>

</style>
